<h1 class="title">Assets</h1>
<h5>Manage Built and General Assets</h5>
<acabim-assets-list-assets controller="admin">
</acabim-assets-list-assets>


